<template>
  <el-form ref="form" size="mini" :model="form" class="bj-query-form bj-query-form-for-cal-height form" :rules="rules">
    <el-row :gutter="20" style="padding: 0 10px">
      <el-col :span="colSpan">
        <el-form-item :label="$t('billingPage.Client')" prop="clientCode">
          <BjSelectLov v-model="form.clientCode" :option-list="clientCodeList" :placeholder="$t('chooseText')" />
        </el-form-item>
      </el-col>
      <el-col :span="colSpan">
        <el-form-item :label="$t('SalesOrderToBeApproved.SKU')" prop="skuCode">
          <BjInput v-model="form.skuCode" :placeholder="$t('inputText')" clearable />
        </el-form-item>
      </el-col>
      <el-col :span="colSpan">
        <el-form-item :label="$t('billingPage.quantity')" prop="quantity">
          <BjInputMoney v-model="form.quantity" :placeholder="$t('inputText')" clearable />
        </el-form-item>
      </el-col>
      <el-col :span="colSpan">
        <el-form-item :label="$t('billingPage.yearAndWeek')" prop="year">
          <el-date-picker id="getWeekDate" v-model="weekDataNow" :picker-options="{ firstDayOfWeek: 1 }" style="width: 100%" type="week" format="yyyy-WW" :clearable="false" :placeholder="$t('billingPage.yearAndWeeks')" @change="dataChange">
          </el-date-picker>
        </el-form-item>
      </el-col>
      <el-col :span="colSpan">
        <el-form-item :label="$t('billingPage.description')" prop="description">
          <BjInput v-model="form.description" type="textarea" autosize show-word-limit :maxlength="MAX_LENGTH.BILLMAX" :placeholder="$t('inputText')" />
        </el-form-item>
      </el-col>
    </el-row>
  </el-form>
</template>

<script>
import moment from 'moment';
export default {
  props: {
    clientCodeList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      colSpan: 8,
      form: {
        clientCode: null,
        quantity: null,
        year: null,
        skuCode: null,
        description: null,
        categoryCode: 'DISPO_FEE',
      },
      weekDataNow: new Date(),
      rules: {
        clientCode: [{ required: true, message: this.$t('chooseText'), trigger: 'change' }],
        quantity: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
        skuCode: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
        year: [{ required: true, message: this.$t('chooseText'), trigger: 'change' }],
      },
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.form.year = document.querySelector('#getWeekDate').value;
    },
    dataChange(val) {
      const time = moment(val).format('YYYY-WW');
      this.form.year = time;
    },
  },
};
</script>
